export enum BaseType {
    Ceiling = "ceiling",
    Chimney = "chimney",
    Drainage = "drainage",
    Facade = "facade",
    Floor = "floor",
    Foundation = "foundation",
    GeoTechnics = "geo_technics",
    InteriorWall = "interior_wall",
    Outdoor = "outdoor",
    Roof = "roof",
    StructuralColumnOrBeam = "structural_column_or_beam",
    StructuralFloor = "structural_floor",
    StructuralFoundation = "structural_foundation",
    StructuralRoof = "structural_roof",
    StructuralWall = "structural_wall",
    Wall = "wall",
    Window = "window",
    Utility = "utility",
}

export enum BuildComponentType {
    FacadeVerticalSiding = "facade_vertical_siding",
    FacadeHorizontalSiding = "facade_horizontal_siding",
    FacadeCavityWall = "facade_cavity_wall",
    FacadeRender = "facade_render",
    FacadeThinRender = "facade_thin_render",
    FacadePlinth = "facade_plinth",
    FacadeSandwichPanel = "facade_sandwich_panel",
    FacadeCorrugatedMetal = "facade_corrugated_metal",

    Geotechnics = "geotechnics",

    FoundationGroundSlab = "foundation_ground_slab",
    FoundationCrawlSpace = "foundation_crawl_space",
    FoundationSlopingSite = "foundation_sloping_site",
    FoundationCellar = "foundation_cellar",
    FoundationPile = "foundation_pile",
    FoundationPier = "foundation_pier",
    FoundationWallOnFooting = "foundation_wall_on_footing",
    FoundationBlindingLayer = "foundation_blinding_layer",
    FoundationRaisedFloor = "foundation_raised_floor",

    ChimneyStack = "chimney_stack",
    ChimneyFlue = "chimney_flue",
    ChimneyCap = "chimney_cap",

    RoofCorrugatedMetal = "roof_corrugated_metal",
    RoofFiberCement = "roof_fiber_cement",
    RoofRolledSheetMetal = "roof_rolled_sheet_metal",
    RoofFelt = "roof_felt",
    RoofSedum = "roof_sedum",
    RoofBrick = "roof_brick",
    RoofConcrete = "roof_concrete",

    DrainageDrainpipe = "drainage_drainpipe",
    DrainageGutter = "drainage_gutter",

    WindowWood = "window_wood",
    WindowAluminium = "window_aluminium",
    WindowPvc = "window_pvc",

    StructuralStudWallInterior = "structural_stud_wall_interior",
    StructuralStudWallExterior = "structural_stud_wall_exterior",
    StructuralSandwichInterior = "structural_sandwich_interior",
    StructuralSandwichExterior = "structural_sandwich_exterior",
    StructuralSolidWallInterior = "structural_solid_wall_interior",
    StructuralSolidWallExterior = "structural_solid_wall_exterior",
    StructuralPanelsInterior = "structural_panels_interior",
    StructuralPanelsExterior = "structural_panels_exterior",
    StructuralConcreteWall = "structural_concrete_wall",
    StructuralBrickWall = "structural_brick_wall",
    StructuralMasonryWall = "structural_masonry_wall",
    StructuralLightweightConcreteWall = "structural_lightweight_concrete_wall",

    StructuralColumnInFacade = "structural_column_in_facade",
    StructuralColumnInteriorWall = "structural_column_interior_wall",
    StructuralButtress = "structural_buttress",
    StructuralExposedBeam = "structural_exposed_beam",
    StructuralConcealedBeam = "structural_concealed_beam",

    StructuralFloorWoodBeam = "structural_floor_wood_beam",
    StructuralFloorSteelBeam = "structural_floor_steel_beam",
    StructuralFloorConcreteBeam = "structural_floor_concrete_beam",
    StructuralFloorSolidSlab = "structural_floor_solid_slab",

    StructuralRoofBeam = "structural_roof_beam",
    StructuralRoofTruss = "structural_roof_truss",
    StructuralRoofLightweightConcreteElement = "structural_roof_lightweight_concrete_element",
    StructuralRoofCassettes = "structural_roof_cassettes",
    StructuralRoofMetalSheetTrp = "structural_roof_metal_sheet_trp",
    StructuralRoofConcrete = "structural_roof_concrete",

    OutdoorTerrace = "outdoor_terrace",
    OutdoorPavedArea = "outdoor_paved_area",
    OutdoorPavement = "outdoor_pavement",
    OutdoorWoodenFence = "outdoor_wooden_fence",
    OutdoorWoodenPlank = "outdoor_wooden_plank",
    OutdoorStoneWall = "outdoor_stone_wall",
    OutdoorGrassArea = "outdoor_grass_area",
    OutdoorParkingGravel = "outdoor_parking_gravel",
    OutdoorParkingAsphalt = "outdoor_parking_asphalt",
    OutdoorPavedAreaStone = "outdoor_paved_area_stone",
    OutdoorPavedAreaAsphalt = "outdoor_paved_area_asphalt",
    OutdoorPermanentFurniture = "outdoor_permanent_furniture",
    OutdoorPlayground = "outdoor_playground",
    OutdoorSwingSet = "outdoor_swing_set",
    OutdoorSandbox = "outdoor_sandbox",
    OutdoorSlide = "outdoor_slide",
    OutdoorOther = "outdoor_other",

    InteriorWall = "interior_wall",
    InteriorCeiling = "interior_ceiling",
    InteriorFloor = "interior_floor",

    UtilityGeothermalHeatPumpEarth = "utility_geothermal_heat_pump_earth",
    UtilityGeothermalHeatPumpBedrock = "utility_geothermal_heat_pump_bedrock",
    UtilityElectricBoiler = "utility_electric_boiler",
    UtilityPelletBoiler = "utility_pellet_boiler",
    UtilityWoodBoiler = "utility_wood_boiler",
    UtilityAirToAirHeatPump = "utility_air_to_air_heat_pump",
    UtilityAirToWaterHeatPump = "utility_air_to_water_heat_pump",
    UtilityAirConditioning = "utility_air_conditioning",
    UtilityDistrictCooling = "utility_district_cooling",
    UtilityPoolHeating = "utility_pool_heating",

    UtilitySVentilation = "utility_s_ventilation",
    UtilityFVentilation = "utility_f_ventilation",
    UtilityFtVentilation = "utility_ft_ventilation",
    UtilityFxVentilation = "utility_fx_ventilation",
    UtilityFtxVentilation = "utility_ftx_ventilation",

    UtilityPassengerElevator = "utility_passenger_elevator",
    UtilityFreightElevator = "utility_freight_elevator",

    UtilitySmokeDetector = "utility_smoke_detector",
    UtilityFireAlarm = "utility_fire_alarm",
    UtilityFireBlanket = "utility_fire_blanket",
    UtilityFireExtinguisher = "utility_fire_extinguisher",
    UtilitySprinkler = "utility_sprinkler",
    UtilityFireControlPanel = "utility_fire_control_panel",

    UtilityMechanicalDehumidification = "utility_mechanical_dehumidification",
    UtilityRadonExtractor = "utility_radon_extractor",
    UtilityVentilatedFloorUnit = "utility_ventilated_floor_unit",
    UtilitySorptionDehumidification = "utility_sorption_dehumidification",
    UtilitySafetyGuardSystem = "utility_safety_guard_system",

    UtilityElectricMainSwitchboard = "utility_electric_main_switchboard",
    UtilityElectricSubSwitchboard = "utility_electric_sub_switchboard"
}

export enum Material {
    Wood = "wood",
    Brick = "brick",
    SheetMetal = "sheet_metal",
    Render = "render",
    RenderThick = "render_thick",
    RenderThin = "render_thin",
    Concrete = "concrete",
    LightweightConcrete = "lightweight_concrete",
    Granite = "granite",
    Aluminum = "aluminum",
    Pvc = "pvc",
    CementBoard = "cement_board",
    MetalWorksOnFacade = "metal_works_on_facade",
    Leca = "leca",
    Steel = "steel",
    CorrugatedMetal = "corrugated_metal",
    FiberCement = "fiber_cement",
    RolledSheetMetal = "rolled_sheet_metal",
    RoofingFelt = "roofing_felt",
    Sedum = "sedum",
    SoilLayer = "soil_layer",
    ConcreteCastInPlace = "concrete_cast_in_place",
    ConcretePrecast = "concrete_precast",
    WoodGlulam = "wood_glulam",
    WoodPrefab = "wood_prefab",
    StructuralTimber = "structural_timber",
    AsbestosCement = "asbestos_cement",
    OrganicMaterial = "organic_material",
    SteelDecking = "steel_decking",
    Stone = "stone",
    Composite = "composite",
    Gravel = "gravel",
    Metal = "metal",
    Grass = "grass",
    Plastic = "plastic",

    ConcretePainted = "concrete_painted",
    Drywall = "drywall",
    DrywallPainted = "drywall_painted",
    DrywallWallpaper = "drywall_wallpaper",
    WoodPanelPainted = "wood_panel_painted",
    WoodPanelBare = "wood_panel_bare",
    RenderPainted = "render_painted",
    CeramicTiles = "ceramic_tiles",
    FloorTiles = "floor_tiles",
    FloorCarpet = "floor_carpet",
    FloorLaminate = "floor_laminate",
    FloorVinyl = "floor_vinyl",
    FloorParquet = "floor_parquet",
    AcousticTiles = "acoustic_tiles",
    DropTiles = "drop_tiles",
    Plywood = "plywood",
}

export enum RiskConstructionType {
    RiskCrawlSpace = "risk_crawl_space",
    RiskSingleStageSealedRender = "risk_single_stage_sealed_render",
    RiskFloatingFloor = "risk_floating_floor",
    RiskUninsulatedSlabOnGround = "risk_uninsulated_slab_on_ground",
    RiskExternallyVentilatedAttic = "risk_externally_ventilated_attic",
    RiskCompactRoofNoAirGap = "risk_compact_roof_no_air_gap",
    RiskInternalDrainage = "risk_internal_drainage",
    RiskLowSlopeRoof = "risk_low_slope_roof",
    RiskBuiltInWaterConnections = "risk_built_in_water_connections",
    RiskExternalWallNoVaporBarrier = "risk_external_wall_no_vapor_barrier",
    RiskUngroundedElectricalSystem = "risk_ungrounded_electrical_system",
    RiskCablesThroughExternalWallRoof = "risk_cables_through_external_wall_roof"
}

export enum UtilityCategory {
    Ventilation = "ventilation",
    HeatingCooling = "heating_cooling",
    Elevator = "elevator",
    FireSafety = "fire_safety",
    MechanicalMaintenanceRiskConstructions = "mechanical_maintenance_risk_constructions",
    Electrical = "electrical",
    WaterAndSewage = "water_and_sewage",
    DoorAutomation = "door_automation"
}

export enum ElevatorType {
    TractionElevator = "traction_elevator",
    Stairlift = "stairlift",
    HydraulicElevator = "hydraulic_elevator"
}

export enum CardinalDirection {
    North = "north",
    NorthEast = "north_east",
    East = "east",
    SouthEast = "south_east",
    South = "south",
    SouthWest = "south_west",
    West = "west",
    NorthWest = "north_west"
}

export enum ColorEnum {
    ColorRed = "color_red",
    ColorOrange = "color_orange",
    ColorYellow = "color_yellow",
    ColorGreen = "color_green",
    ColorBlue = "color_blue",
    ColorPurple = "color_purple",
    ColorPink = "color_pink",
    ColorWhite = "color_white",
    ColorBlack = "color_black",
    ColorBrown = "color_brown"
}

export enum HazardType {
    HazardAsbestos = "hazard_asbestos",
    HazardLed = "hazard_led",
    HazardPcb = "hazard_pcb",
    HazardArsenic = "hazard_arsenic",
    HazardBlueConcrete = "hazard_blue_concrete",
    HazardRadon = "hazard_radon"
}

export enum RoofShape {
    RoofShapeGable = "roof_shape_gable",
    RoofShapeMansard = "roof_shape_mansard",
    RoofShapeHip = "roof_shape_hip",
    RoofShapeShed = "roof_shape_shed",
    RoofShapeInvertedShed = "roof_shape_inverted_shed",
    RoofShapeCylindrical = "roof_shape_cylindrical",
    RoofShapeFlat = "roof_shape_flat"
}

export enum RoomType {
    RoomGeneral = "room_general",
    RoomKitchen = "room_kitchen",
    RoomAssembly = "room_assembly",
    RoomOffice = "room_office",
    RoomBathroom = "room_bathroom",
    RoomStorage = "room_storage",
    RoomUtility = "room_utility",
    RoomEntryway = "room_entryway",
    RoomHallway = "room_hallway",
    RoomChanging = "room_changing",
    RoomWork = "room_work",
    RoomConference = "room_conference",
    RoomLecture = "room_lecture",
    RoomExhibit = "room_exhibit",
    RoomWarmAttic = "room_warm_attic",
    RoomColdAttic = "room_cold_attic",
}

export enum HazardousState {
    Suspected = "SUSPECTED",
    Confirmed = "CONFIRMED"
}

export enum WindowPaneType {
    OnePane = "one_pane",
    TwoPane = "two_pane",
    ThreePane = "three_pane",
}

export enum LevelType {
    Basement = "basement",
    GroundFloor = "ground_floor",
    NthFloor = "nth_floor",
    Attic = "attic"
}
